<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <a-table
        :loading="loading"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :pagination="false">
        <span slot="appType" slot-scope="text, record">
          {{ record.appType === 0 ? 'Android' : 'IOS' }}
        </span>
        <span slot="operation" slot-scope="text, record">
          <a @click="handleEdit(record)">
            <a-icon type="edit" />编辑
          </a>
        </span>
      </a-table>
    </a-card>

    <CreateForm ref="createForm" @ok="handleQuery" />
  </page-header-wrapper>
</template>
<script>
import { qryDeviceData } from '@/api/com/version'
import CreateForm from './components/CreateForm.vue'
export default {
  name: '',
  components: { CreateForm },
  data () {
    return {
      loading: false,
      columns: [
        { title: 'APP类型', dataIndex: 'appType', scopedSlots: { customRender: 'appType' }, align: 'center' },
        { title: '版本号', dataIndex: 'versionCode', align: 'center' },
        { title: '版本名称', dataIndex: 'versionName', align: 'center' },
        { title: '操作', dataIndex: 'operation', scopedSlots: { customRender: 'operation' }, align: 'center' }
      ],
      listQuery: {
        current: 1,
        size: 10
      },
      total: 0,
      list: []
    }
  },
  created () {
    this.getList()
  },
  methods: {
    getList() {
      qryDeviceData(this.listQuery).then(res => {
        console.log('===', res)
        this.list = res.data.records
        this.total = Number(res.data.total)
      })
    },
    handleEdit(info) {
      this.$nextTick(() => {
        this.$refs.createForm.init(info)
      })
    },
    // 查询
    handleQuery() {
      this.listQuery.current = 1
      this.getList()
    },
    resetQuery() {
      this.listQuery = {
        current: 1,
        size: 10
      }
      this.getList()
    }
  }
}
</script>

<style lang='scss' scoped>

</style>
